import type { ClientKind } from '@/kinds/kind'
import { applyIssue, applyPull, issueDefaults, issueDisplayName, issueInitialStatus, pullDefaults, pullDisplayName, pullInitialStatus } from './apply'
import { gitIssueSpec, gitIssueStatus, pullRequestSpec, pullRequestStatus, type GitIssueSpec, type GitIssueStatus, type PullRequestSpec, type PullRequestStatus } from './schema'
import { IssueDetail, IssueListRow, PullDetail, PullListRow } from './components'

const Nothing = () => null

export const gitIssueKind: ClientKind<GitIssueSpec, GitIssueStatus> = {
  name: 'GitIssue',
  version: 1,
  spec: gitIssueSpec,
  status: gitIssueStatus,
  defaults: issueDefaults,
  validate: () => [],
  initialStatus: issueInitialStatus,
  displayName: issueDisplayName,
  apply: applyIssue,
  actions: ['comment', 'close', 'reopen', 'link_task'],
  ListRow: IssueListRow,
  Detail: IssueDetail,
  Form: Nothing,
  workspaceScoped: true,
}

export const pullRequestKind: ClientKind<PullRequestSpec, PullRequestStatus> = {
  name: 'PullRequest',
  version: 1,
  spec: pullRequestSpec,
  status: pullRequestStatus,
  defaults: pullDefaults,
  validate: () => [],
  initialStatus: pullInitialStatus,
  displayName: pullDisplayName,
  apply: applyPull,
  actions: ['approve', 'request_changes', 'comment', 'merge', 'close', 'reopen'],
  ListRow: PullListRow,
  Detail: PullDetail,
  Form: Nothing,
  workspaceScoped: true,
}

export * from './schema'
export type { GitIssueResource, PullRequestResource } from './apply'
